import { jsx as _jsx } from "react/jsx-runtime";
export default function Pattern(_ref) {
  let {
    id,
    width,
    height,
    children
  } = _ref;
  return /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("pattern", {
      id: id,
      width: width,
      height: height,
      patternUnits: "userSpaceOnUse",
      children: children
    })
  });
}